import { Card, NumberField, Typography } from "@hellocarbo/lasagne";
import { useTranslation } from "react-i18next";

type ScopesCardProps = {
  scopes: { parent: string; children: Array<string> };
  externalCampaignBegesScopesCarbon: Record<string, number>;
  disabled: boolean;
};

function ScopesCard({
  scopes,
  externalCampaignBegesScopesCarbon,
  disabled,
}: ScopesCardProps) {
  const { t } = useTranslation(["scopes"]);

  return (
    <Card isFlat className="mb-sm">
      <Typography step="2" weight="bold" as="h2" className="mb-xs">
        {t(`scopes:beges.${scopes.parent}`)}
      </Typography>
      <ul className="gap-xs flex flex-col">
        {scopes.children.map((child) => (
          <li key={child.replace(".", "-")}>
            <div className="gap-xs px-md flex flex-row items-center">
              <Typography step="0">{child}</Typography>
              <Typography step="0" className="grow-1">
                {t("scopes:beges." + child.replace(".", "-"))}
              </Typography>
              <div className="flex-none">
                <NumberField
                  name={child}
                  unit="tCO2e"
                  step="0.001"
                  defaultValue={externalCampaignBegesScopesCarbon[child]}
                  disabled={disabled}
                  fullWidth
                />
              </div>
            </div>
          </li>
        ))}
      </ul>
    </Card>
  );
}

export default ScopesCard;
